import { useRef, useState, useEffect } from "react";
import "./Header.scss";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import Logo from "../../assets/Logo.svg";
import champer from "../../assets/champer.svg";
// import {
// 	IconButton,
// 	InputAdornment,
// 	InputBase,
// } from '@mui/material';
import ShopMegaMenu from "../shopMegaMenu/ShopMegaMenu";
import { FaChevronDown, FaAngleRight } from "react-icons/fa";
import ServiceMenu from "./ServiceMenu";
import { FaAngleDown } from "react-icons/fa6";
import SearchBarComponent from "../SearchBarComponent/SearchBarComponent";
import { useSelector } from "react-redux";
import {
  selectTotalPrice,
  selectWishlistProducts,
} from "../../utils/features/cart";
import PropTypes from "prop-types";

const Header = ({ handleOpen }) => {
  const Desktop = useMediaQuery("(min-width:1020px)");
  const navbar = useRef(null);
  const [User, setUser] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [serviceSelected, setSeletedService] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowMobileMenu(0);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(navbar);

  const handleMobileLinkClick = (link) => {
    setShowMobileMenu(false);
    navigate(link);
  };

  const totalPrice = useSelector(selectTotalPrice);

  const wishlistProducts = useSelector(selectWishlistProducts);

  return (
    <div
      className="Navbar"
      ref={navbar}
      onMouseLeave={() => setSeletedService("")}
    >
      {Desktop ? (
        <div className="wrapper">
          <div className="upper" onMouseEnter={() => setSeletedService("")}>
            <div className="logo">
              <Link to={"/"} aria-label="Logo">
                <img src={Logo} alt="Logo" />
              </Link>
            </div>
            <div className="right">
              {/* <div className="search_box_wrap">
                <InputBase
                  className="mui-register-password"
                  type="text"
                  placeholder="Search"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton edge="end" aria-label="Search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                            stroke="#616161"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M13.9996 13.9996L11.0996 11.0996"
                            stroke="#616161"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div> */}
              <SearchBarComponent />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1"
                height="32"
                viewBox="0 0 1 32"
                fill="none"
              >
                <path opacity="0.2" d="M0.509766 0.25V31.75" stroke="black" />
              </svg>
              <img src={champer} alt="champer logo" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2"
                height="32"
                viewBox="0 0 2 32"
                fill="none"
              >
                <path opacity="0.2" d="M1 0.25V31.75" stroke="black" />
              </svg>
              <div className="likes" onClick={() => navigate("/wishlist")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.89858 0.859905C8.57858 0.981619 10.3306 1.80276 12.0071 3.46048C13.6837 1.80105 15.434 0.983333 17.1123 0.865048C19.0083 0.729619 20.6831 1.4959 21.8951 2.70448C24.278 5.08048 25.0271 9.38162 22.07 12.3388C22.06 12.3487 22.0497 12.3585 22.0391 12.3679L12.5831 20.9342C12.4254 21.0773 12.2201 21.1566 12.0071 21.1566C11.7942 21.1566 11.5889 21.0773 11.4311 20.9342L1.97515 12.3679C1.96462 12.3584 1.95433 12.3487 1.94429 12.3388C-1.02828 9.36619 -0.284279 5.06505 2.10715 2.69076C3.32258 1.4839 5.00086 0.722762 6.89858 0.859905Z"
                    fill="#008FD5"
                  />
                </svg>
                <p className="likes_number">{wishlistProducts.length}</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2"
                height="32"
                viewBox="0 0 2 32"
                fill="none"
              >
                <path opacity="0.2" d="M1 0.25V31.75" stroke="black" />
              </svg>
              <div className="Mini_Cart likes" onClick={handleOpen}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_28_301)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.28571 2.57143H3.67886L4.32857 5.04C4.33384 5.05956 4.33955 5.07899 4.34571 5.09829L6.00514 13.404C6.00967 13.4489 6.01654 13.4935 6.02571 13.5377L6.74571 17.1377V17.1429C6.84451 17.6269 7.10751 18.0619 7.49018 18.3743C7.87286 18.6867 8.35172 18.8572 8.84571 18.8571H19.2857C19.6267 18.8571 19.9537 18.7217 20.1949 18.4806C20.436 18.2394 20.5714 17.9124 20.5714 17.5714C20.5714 17.2304 20.436 16.9034 20.1949 16.6623C19.9537 16.4212 19.6267 16.2857 19.2857 16.2857H9.19714L8.76857 14.1429H20.7429H20.76H20.7617C20.8217 14.1429 20.9931 14.148 21.1509 14.1223C21.4336 14.0745 21.7 13.9572 21.9262 13.7809C22.1525 13.6047 22.3313 13.375 22.4469 13.1126C22.5394 12.9 22.5857 12.6309 22.6011 12.5417L22.6063 12.5177L23.9623 5.89714L23.9657 5.88C24.0105 5.63341 24.0008 5.37998 23.9372 5.13756C23.8736 4.89513 23.7576 4.66958 23.5975 4.47677C23.4373 4.28396 23.2369 4.12856 23.0103 4.02152C22.7837 3.91447 22.5363 3.85836 22.2857 3.85714H22.2823H6.67371L6.10286 1.67143C5.99581 1.19677 5.7304 0.772673 5.3503 0.468898C4.97019 0.165122 4.49801 -0.000243071 4.01143 2.68176e-07H1.28571C0.944722 2.68176e-07 0.617695 0.135459 0.376577 0.376577C0.135459 0.617695 0 0.944722 0 1.28571C0 1.62671 0.135459 1.95373 0.376577 2.19485C0.617695 2.43597 0.944722 2.57143 1.28571 2.57143ZM19.9371 21.9429C19.9371 21.4205 19.7296 20.9195 19.3602 20.5501C18.9908 20.1807 18.4898 19.9731 17.9674 19.9731C17.445 19.9731 16.944 20.1807 16.5746 20.5501C16.2052 20.9195 15.9977 21.4205 15.9977 21.9429C16.0128 22.455 16.2269 22.941 16.5945 23.2979C16.9621 23.6548 17.4542 23.8545 17.9666 23.8545C18.4789 23.8545 18.9711 23.6548 19.3387 23.2979C19.7063 22.941 19.9203 22.455 19.9354 21.9429H19.9371ZM9.39429 19.9749C9.65773 19.9671 9.92005 20.0123 10.1657 20.1077C10.4114 20.2032 10.6354 20.3469 10.8245 20.5305C11.0136 20.7141 11.1639 20.9338 11.2666 21.1765C11.3692 21.4193 11.4221 21.6802 11.4221 21.9437C11.4221 22.2073 11.3692 22.4681 11.2666 22.7109C11.1639 22.9536 11.0136 23.1733 10.8245 23.3569C10.6354 23.5405 10.4114 23.6843 10.1657 23.7797C9.92005 23.8752 9.65773 23.9203 9.39429 23.9126C8.88217 23.8975 8.39609 23.6834 8.0392 23.3158C7.6823 22.9482 7.48267 22.4561 7.48267 21.9437C7.48267 21.4314 7.6823 20.9392 8.0392 20.5716C8.39609 20.204 8.88217 19.99 9.39429 19.9749Z"
                      fill="#008FD5"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_28_301">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <p className="likes_number">${Number(totalPrice).toFixed(2)}</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2"
                height="32"
                viewBox="0 0 2 32"
                fill="none"
              >
                <path opacity="0.2" d="M1 0.25V31.75" stroke="black" />
              </svg>
              {User ? (
                <div className="myaccountwrap">
                  {/* <div className='my_account likes'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'>
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M24 12.0001C24.0041 15.0907 22.8116 18.0629 20.6726 20.2938C19.5575 21.4627 18.2172 22.3937 16.7326 23.0307C15.248 23.6676 13.6498 23.9974 12.0343 24.0001H12H11.9657C10.3502 23.9974 8.75201 23.6676 7.2674 23.0307C5.78278 22.3937 4.44253 21.4627 3.32743 20.2938C1.97134 18.8757 0.983649 17.1468 0.450868 15.2585C-0.0819123 13.3701 -0.143526 11.3799 0.271423 9.46219C0.686372 7.54449 1.56523 5.75779 2.831 4.25859C4.09677 2.7594 5.71085 1.59345 7.53185 0.862875C9.35285 0.132301 11.3252 -0.140608 13.2762 0.0680541C15.2271 0.276716 17.0972 0.960582 18.7225 2.05975C20.3478 3.15892 21.6787 4.63985 22.5988 6.37283C23.5189 8.10581 24 10.038 24 12.0001ZM19.2737 18.0001C18.3899 16.9267 17.2792 16.0625 16.0215 15.4697C14.7639 14.8768 13.3904 14.5701 12 14.5715C10.6096 14.5701 9.23615 14.8768 7.97846 15.4697C6.72076 16.0625 5.61008 16.9267 4.72629 18.0001C5.61008 19.0734 6.72076 19.9376 7.97846 20.5305C9.23615 21.1233 10.6096 21.43 12 21.4286C13.3904 21.43 14.7639 21.1233 16.0215 20.5305C17.2792 19.9376 18.3899 19.0734 19.2737 18.0001ZM12 12.8572C12.5628 12.8572 13.1201 12.7463 13.6401 12.531C14.16 12.3156 14.6325 11.9999 15.0305 11.6019C15.4284 11.204 15.7441 10.7315 15.9595 10.2116C16.1749 9.69158 16.2857 9.13429 16.2857 8.57148C16.2857 8.00867 16.1749 7.45138 15.9595 6.93141C15.7441 6.41144 15.4284 5.93899 15.0305 5.54102C14.6325 5.14306 14.16 4.82737 13.6401 4.612C13.1201 4.39662 12.5628 4.28577 12 4.28577C10.8634 4.28577 9.77327 4.7373 8.96954 5.54102C8.16582 6.34475 7.71429 7.43484 7.71429 8.57148C7.71429 9.70812 8.16582 10.7982 8.96954 11.6019C9.77327 12.4057 10.8634 12.8572 12 12.8572Z'
                        fill='#008FD5'
                      />
                    </svg>
                    <p className='likes_number'>My Account</p>
                  </div> */}
                  <Link className="Rebate" to="/RebateProgram">
                    $5000 Rebate
                  </Link>
                </div>
              ) : (
                <div className="loginbuttons">
                  <button className="Signup">Sign Up</button>
                  <button className="Login">Log in</button>
                </div>
              )}
            </div>
          </div>
          <div className="lower">
            <div className="menuWrap">
              <div className="left">
                <div
                  className={`hoverLink ${
                    serviceSelected === "Plumbing" ? "active" : ""
                  }`}
                  // onMouseLeave={() => setSeletedService('')}
                  onMouseEnter={() => setSeletedService("Plumbing")}
                >
                  Plumbing <FaChevronDown className="icon" />
                </div>
                <div
                  className={`hoverLink ${
                    serviceSelected === "Heating" ? "active" : ""
                  }`}
                  // onMouseLeave={() => setSeletedService('')}
                  onMouseEnter={() => setSeletedService("Heating")}
                >
                  Heating <FaChevronDown className="icon" />
                </div>
                <div
                  className={`hoverLink ${
                    serviceSelected === "Water Treatment" ? "active" : ""
                  }`}
                  // onMouseLeave={() => setSeletedService('')}
                  onMouseEnter={() => setSeletedService("Water Treatment")}
                >
                  Water Treatment <FaChevronDown className="icon" />
                </div>
                <div
                  className={`hoverLink ${
                    serviceSelected === "Serving Areas" ? "active" : ""
                  }`}
                  // onMouseLeave={() => setSeletedService('')}
                  onMouseEnter={() => setSeletedService("Serving Areas")}
                >
                  Serving Areas <FaChevronDown className="icon" />
                </div>
                <Link to="/RebateProgram">Rebate</Link>
                <Link to="/about">About</Link>
                <Link to="/contact">Contact</Link>
              </div>
              <div className="right">
                <button
                  onClick={() => {
                    setSeletedService("");
                    setShowMegaMenu(!showMegaMenu);
                  }}
                  className={`categories ${showMegaMenu ? "open" : ""}`}
                >
                  Shop by categories <FaAngleDown className="innerIcon" />
                </button>
                <a className="Emergency" href="tel:+6132675206">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M8.05338 2.5C8.20812 2.49996 8.36003 2.54008 8.49319 2.61617C8.62636 2.69226 8.73589 2.80152 8.81032 2.9325L8.85434 3.02417L10.5805 7.19083C10.6501 7.35846 10.6613 7.54337 10.6126 7.7177C10.5639 7.89204 10.4578 8.04638 10.3104 8.1575L10.2241 8.21417L8.77925 9.05083L8.83362 9.13666C9.5213 10.1908 10.445 11.0827 11.5368 11.7467L11.6249 11.7983L12.4923 10.405C12.5884 10.2501 12.7341 10.1295 12.9073 10.0614C13.0806 9.99331 13.272 9.98142 13.4529 10.0275L13.5522 10.06L17.8676 11.7267C18.0113 11.782 18.137 11.8736 18.2314 11.9919C18.3259 12.1103 18.3856 12.2509 18.4045 12.3992L18.4105 12.5V15.8333C18.4105 17.2142 17.2514 18.3333 15.7695 18.3317C8.36496 17.8975 2.46225 12.1983 2.01172 5C2.01168 4.36232 2.26402 3.74874 2.71711 3.28478C3.1702 2.82083 3.78979 2.54158 4.4491 2.50417L4.601 2.5H8.05338Z"
                      fill="#008FD5"
                    />
                  </svg>
                  <div className="textwrap">
                    <p className="blue">Emergency</p>
                    <p className="black">613-267-5206</p>
                  </div>
                </a>
                {/* {User && (
                  <div className='userNotificatin'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='2'
                      height='32'
                      viewBox='0 0 2 32'
                      fill='none'>
                      <path opacity='0.2' d='M1 0.25V31.75' stroke='black' />
                    </svg>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                      className='notification'>
                      <path
                        d='M14.235 19C15.1 19 15.557 20.024 14.98 20.668C14.6051 21.0875 14.1459 21.4229 13.6323 21.6525C13.1188 21.8821 12.5625 22.0005 12 22C11.4374 22.0005 10.8812 21.8821 10.3676 21.6525C9.85404 21.4229 9.3948 21.0875 9.01997 20.668C8.46797 20.052 8.86197 19.089 9.65397 19.007L9.76397 19.001L14.235 19Z'
                        fill='#008FD5'
                      />
                      <path
                        d='M11.9999 2C13.3579 2 14.5059 2.903 14.8749 4.141L14.9209 4.312L14.9289 4.355C16.0313 4.9769 16.9707 5.8511 17.6702 6.906C18.3696 7.9609 18.8092 9.16648 18.9529 10.424L18.9809 10.711L18.9999 11V13.931L19.0209 14.067C19.1579 14.8038 19.5656 15.4627 20.1639 15.914L20.3309 16.031L20.4929 16.13C21.3529 16.617 21.0529 17.896 20.1159 17.994L19.9999 18H3.99995C2.97195 18 2.61295 16.636 3.50695 16.13C3.88798 15.9144 4.21719 15.618 4.47149 15.2616C4.72578 14.9052 4.89899 14.4974 4.97895 14.067L4.99995 13.924L5.00095 10.954C5.06192 9.64788 5.44211 8.37661 6.10823 7.25147C6.77436 6.12632 7.70611 5.18161 8.82195 4.5L9.06995 4.354L9.07995 4.311C9.2214 3.71303 9.54289 3.17284 10.001 2.76334C10.4592 2.35384 11.0319 2.09473 11.6419 2.021L11.8239 2.004L11.9999 2Z'
                        fill='#008FD5'
                      />
                      <path
                        d='M14.235 19C15.1 19 15.557 20.024 14.98 20.668C14.6051 21.0875 14.1459 21.4229 13.6323 21.6525C13.1188 21.8821 12.5625 22.0005 12 22C11.4374 22.0005 10.8812 21.8821 10.3676 21.6525C9.85404 21.4229 9.3948 21.0875 9.01997 20.668C8.46797 20.052 8.86197 19.089 9.65397 19.007L9.76397 19.001L14.235 19Z'
                        stroke='#008FD5'
                      />
                      <path
                        d='M11.9999 2C13.3579 2 14.5059 2.903 14.8749 4.141L14.9209 4.312L14.9289 4.355C16.0313 4.9769 16.9707 5.8511 17.6702 6.906C18.3696 7.9609 18.8092 9.16648 18.9529 10.424L18.9809 10.711L18.9999 11V13.931L19.0209 14.067C19.1579 14.8038 19.5656 15.4627 20.1639 15.914L20.3309 16.031L20.4929 16.13C21.3529 16.617 21.0529 17.896 20.1159 17.994L19.9999 18H3.99995C2.97195 18 2.61295 16.636 3.50695 16.13C3.88798 15.9144 4.21719 15.618 4.47149 15.2616C4.72578 14.9052 4.89899 14.4974 4.97895 14.067L4.99995 13.924L5.00095 10.954C5.06192 9.64788 5.44211 8.37661 6.10823 7.25147C6.77436 6.12632 7.70611 5.18161 8.82195 4.5L9.06995 4.354L9.07995 4.311C9.2214 3.71303 9.54289 3.17284 10.001 2.76334C10.4592 2.35384 11.0319 2.09473 11.6419 2.021L11.8239 2.004L11.9999 2Z'
                        stroke='#008FD5'
                      />
                    </svg>
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <ShopMegaMenu shown={showMegaMenu} setMegaShown={setShowMegaMenu} />
        </div>
      ) : (
        <div className="mobileNav">
          <div className="Mwrapper">
            <div className="upper">
              <div className="logo">
                <Link to={"/"} aria-label="Logo">
                  <img src={Logo} alt="Logo" />
                </Link>
              </div>
              <div className="right">
                <svg
                  onClick={() => navigate("/wishlist")}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.89858 0.859905C8.57858 0.981619 10.3306 1.80276 12.0071 3.46048C13.6837 1.80105 15.434 0.983333 17.1123 0.865048C19.0083 0.729619 20.6831 1.4959 21.8951 2.70448C24.278 5.08048 25.0271 9.38162 22.07 12.3388C22.06 12.3487 22.0497 12.3585 22.0391 12.3679L12.5831 20.9342C12.4254 21.0773 12.2201 21.1566 12.0071 21.1566C11.7942 21.1566 11.5889 21.0773 11.4311 20.9342L1.97515 12.3679C1.96462 12.3584 1.95433 12.3487 1.94429 12.3388C-1.02828 9.36619 -0.284279 5.06505 2.10715 2.69076C3.32258 1.4839 5.00086 0.722762 6.89858 0.859905Z"
                    fill="#008FD5"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="2"
                  height="32"
                  viewBox="0 0 2 32"
                  fill="none"
                >
                  <path opacity="0.2" d="M1 0.25V31.75" stroke="black" />
                </svg>
                <svg
                  onClick={handleOpen}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_612_16212)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M1.28571 2.57143H3.67886L4.32857 5.04C4.33384 5.05956 4.33955 5.07899 4.34571 5.09829L6.00514 13.404C6.00967 13.4489 6.01654 13.4935 6.02571 13.5377L6.74571 17.1377V17.1429C6.84451 17.6269 7.10751 18.0619 7.49018 18.3743C7.87286 18.6867 8.35172 18.8572 8.84571 18.8571H19.2857C19.6267 18.8571 19.9537 18.7217 20.1949 18.4806C20.436 18.2394 20.5714 17.9124 20.5714 17.5714C20.5714 17.2304 20.436 16.9034 20.1949 16.6623C19.9537 16.4212 19.6267 16.2857 19.2857 16.2857H9.19714L8.76857 14.1429H20.7429H20.76H20.7617C20.8217 14.1429 20.9931 14.148 21.1509 14.1223C21.4336 14.0745 21.7 13.9572 21.9262 13.7809C22.1525 13.6047 22.3313 13.375 22.4469 13.1126C22.5394 12.9 22.5857 12.6309 22.6011 12.5417L22.6063 12.5177L23.9623 5.89714L23.9657 5.88C24.0105 5.63341 24.0008 5.37998 23.9372 5.13756C23.8736 4.89513 23.7576 4.66958 23.5975 4.47677C23.4373 4.28396 23.2369 4.12856 23.0103 4.02152C22.7837 3.91447 22.5363 3.85836 22.2857 3.85714H22.2823H6.67371L6.10286 1.67143C5.99581 1.19677 5.7304 0.772673 5.3503 0.468898C4.97019 0.165122 4.49801 -0.000243071 4.01143 2.68176e-07H1.28571C0.944722 2.68176e-07 0.617695 0.135459 0.376577 0.376577C0.135459 0.617695 0 0.944722 0 1.28571C0 1.62671 0.135459 1.95373 0.376577 2.19485C0.617695 2.43597 0.944722 2.57143 1.28571 2.57143ZM19.9371 21.9429C19.9371 21.4205 19.7296 20.9195 19.3602 20.5501C18.9908 20.1807 18.4898 19.9731 17.9674 19.9731C17.445 19.9731 16.944 20.1807 16.5746 20.5501C16.2052 20.9195 15.9977 21.4205 15.9977 21.9429C16.0128 22.455 16.2269 22.941 16.5945 23.2979C16.9621 23.6548 17.4542 23.8545 17.9666 23.8545C18.4789 23.8545 18.9711 23.6548 19.3387 23.2979C19.7063 22.941 19.9203 22.455 19.9354 21.9429H19.9371ZM9.39429 19.9749C9.65773 19.9671 9.92005 20.0123 10.1657 20.1077C10.4114 20.2032 10.6354 20.3469 10.8245 20.5305C11.0136 20.7141 11.1639 20.9338 11.2666 21.1765C11.3692 21.4193 11.4221 21.6802 11.4221 21.9437C11.4221 22.2073 11.3692 22.4681 11.2666 22.7109C11.1639 22.9536 11.0136 23.1733 10.8245 23.3569C10.6354 23.5405 10.4114 23.6843 10.1657 23.7797C9.92005 23.8752 9.65773 23.9203 9.39429 23.9126C8.88217 23.8975 8.39609 23.6834 8.0392 23.3158C7.6823 22.9482 7.48267 22.4561 7.48267 21.9437C7.48267 21.4314 7.6823 20.9392 8.0392 20.5716C8.39609 20.204 8.88217 19.99 9.39429 19.9749Z"
                      fill="#008FD5"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_612_16212">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {/* <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='2'
                  height='32'
                  viewBox='0 0 2 32'
                  fill='none'>
                  <path opacity='0.2' d='M1 0.25V31.75' stroke='black' />
                </svg>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M24 12.0001C24.0041 15.0907 22.8116 18.0629 20.6726 20.2938C19.5575 21.4627 18.2172 22.3937 16.7326 23.0307C15.248 23.6676 13.6498 23.9974 12.0343 24.0001H12H11.9657C10.3502 23.9974 8.75201 23.6676 7.2674 23.0307C5.78278 22.3937 4.44253 21.4627 3.32743 20.2938C1.97134 18.8757 0.983649 17.1468 0.450868 15.2585C-0.0819123 13.3701 -0.143526 11.3799 0.271423 9.46219C0.686372 7.54449 1.56523 5.75779 2.831 4.25859C4.09677 2.7594 5.71085 1.59345 7.53185 0.862875C9.35285 0.132301 11.3252 -0.140608 13.2762 0.0680541C15.2271 0.276716 17.0972 0.960582 18.7225 2.05975C20.3478 3.15892 21.6787 4.63985 22.5988 6.37283C23.5189 8.10581 24 10.038 24 12.0001ZM19.2737 18.0001C18.3899 16.9267 17.2792 16.0625 16.0215 15.4697C14.7639 14.8768 13.3904 14.5701 12 14.5715C10.6096 14.5701 9.23615 14.8768 7.97846 15.4697C6.72076 16.0625 5.61008 16.9267 4.72629 18.0001C5.61008 19.0734 6.72076 19.9376 7.97846 20.5305C9.23615 21.1233 10.6096 21.43 12 21.4286C13.3904 21.43 14.7639 21.1233 16.0215 20.5305C17.2792 19.9376 18.3899 19.0734 19.2737 18.0001ZM12 12.8572C12.5628 12.8572 13.1201 12.7463 13.6401 12.531C14.16 12.3156 14.6325 11.9999 15.0305 11.6019C15.4284 11.204 15.7441 10.7315 15.9595 10.2116C16.1749 9.69158 16.2857 9.13429 16.2857 8.57148C16.2857 8.00867 16.1749 7.45138 15.9595 6.93141C15.7441 6.41144 15.4284 5.93899 15.0305 5.54102C14.6325 5.14306 14.16 4.82737 13.6401 4.612C13.1201 4.39662 12.5628 4.28577 12 4.28577C10.8634 4.28577 9.77327 4.7373 8.96954 5.54102C8.16582 6.34475 7.71429 7.43484 7.71429 8.57148C7.71429 9.70812 8.16582 10.7982 8.96954 11.6019C9.77327 12.4057 10.8634 12.8572 12 12.8572Z'
                    fill='#008FD5'
                  />
                </svg> */}
              </div>
            </div>
            <div className="lower">
              <div>
                {showMobileMenu ? (
                  <AiOutlineClose
                    className="menu-icon"
                    onClick={() => setShowMobileMenu(!showMobileMenu)}
                  />
                ) : (
                  <AiOutlineMenu
                    className="menu-icon"
                    onClick={() => setShowMobileMenu(!showMobileMenu)}
                  />
                )}
                <div
                  className={`dropdown-links-wrapper ${
                    showMobileMenu ? "shown" : ""
                  }`}
                >
                  <div
                    className={`scrollDiv ${serviceSelected ? "active" : ""}`}
                  >
                    <div className="links_wrapper">
                      <span
                        className="navTabService"
                        onClick={() => setSeletedService("Plumbing")}
                      >
                        Plumbing <FaAngleRight className="icon" />
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => setSeletedService("Heating")}
                      >
                        Heating <FaAngleRight className="icon" />
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => setSeletedService("Water Treatment")}
                      >
                        Water Treatment <FaAngleRight className="icon" />
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => setSeletedService("Serving Areas")}
                      >
                        Serving Areas <FaAngleRight className="icon" />
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => handleMobileLinkClick("/RebateProgram")}
                      >
                        Rebate
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => handleMobileLinkClick("/About")}
                      >
                        About
                      </span>
                      <span
                        className="navTabService"
                        onClick={() => handleMobileLinkClick("/Contact")}
                      >
                        Contact
                      </span>
                    </div>
                    <ServiceMenu
                      serviceName={serviceSelected}
                      setServiceName={setSeletedService}
                      handleMobileLinkClick={handleMobileLinkClick}
                    />
                  </div>
                </div>
              </div>
              <div className="right">
                <a className="call" href="tel:+6132675206">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9 3C9.17928 2.99995 9.35528 3.0481 9.50957 3.13941C9.66386 3.23071 9.79076 3.36182 9.877 3.519L9.928 3.629L11.928 8.629C12.0086 8.83016 12.0216 9.05204 11.9651 9.26125C11.9087 9.47045 11.7858 9.65566 11.615 9.789L11.515 9.857L9.841 10.861L9.904 10.964C10.7008 12.229 11.771 13.2992 13.036 14.096L13.138 14.158L14.143 12.486C14.2544 12.3001 14.4231 12.1554 14.6239 12.0737C14.8246 11.992 15.0464 11.9777 15.256 12.033L15.371 12.072L20.371 14.072C20.5375 14.1384 20.6831 14.2484 20.7925 14.3903C20.9019 14.5323 20.9712 14.7011 20.993 14.879L21 15V19C21 20.657 19.657 22 17.94 21.998C9.361 21.477 2.522 14.638 2 6C1.99996 5.23479 2.29233 4.49848 2.81728 3.94174C3.34224 3.38499 4.06011 3.04989 4.824 3.005L5 3H9Z"
                      fill="#008FD5"
                    />
                  </svg>{" "}
                  613.267.5206
                </a>
                {/* <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='2'
                  height='32'
                  viewBox='0 0 2 32'
                  fill='none'>
                  <path opacity='0.2' d='M1 0.25V31.75' stroke='black' />
                </svg>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='25'
                  height='24'
                  viewBox='0 0 25 24'
                  fill='none'>
                  <path
                    d='M11.1434 19.7143C16.3507 19.7143 20.572 15.493 20.572 10.2857C20.572 5.07849 16.3507 0.857178 11.1434 0.857178C5.93615 0.857178 1.71484 5.07849 1.71484 10.2857C1.71484 15.493 5.93615 19.7143 11.1434 19.7143Z'
                    stroke='#008FD5'
                    strokeWidth='1.71429'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M24 23.1428L18 17.1428'
                    stroke='#008FD5'
                    strokeWidth='1.71429'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {Desktop && (
        <ServiceMenu
          serviceName={serviceSelected}
          setServiceName={setSeletedService}
        />
      )}
    </div>
  );
};

Header.propTypes = {
  handleOpen: PropTypes.func,
};

export default Header;
